import {
  GET_PARTICIPANTS,
  SET_PARTICIPANTS,
  UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL,
  UPDATE_CURRENT_PARTICIPANT_BILLABLE_ENTITY,
  UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS,
} from './participantsConstants';
import { EParticipant } from '../../models/entities/participant/participant';
import { DsoDetails } from '../../models/entities/participant/dsoDetails';
import { BillingDetail } from '../../models/entities/participant/billingDetail';
import { BillableEntity } from '../../models/entities/billing-new/billableEntity';

export const ParticipantsActions = {
  updateCurrentParticipantDsoDetails(dsoDetails: DsoDetails | null) {
    return { type: UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS, payload: { dsoDetails } };
  },
  updateCurrentParticipantBillingDetail(billingDetail: BillingDetail | null) {
    return { type: UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL, payload: { billingDetail } };
  },
  updateCurrentParticipantBillableEntity(billableEntity: BillableEntity | null) {
    return { type: UPDATE_CURRENT_PARTICIPANT_BILLABLE_ENTITY, payload: { billableEntity } };
  },
  getParticipants() {
    return { type: GET_PARTICIPANTS };
  },
  setParticipants(participants: EParticipant[] | null) {
    return { type: SET_PARTICIPANTS, payload: { participants } };
  },
};
